"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZksyncService = void 0;
const axios_1 = __importDefault(require("axios"));
const networks_1 = require("./networks");
const base_network_service_1 = require("./base-network.service");
const ethers_1 = require("ethers");
const url = __importStar(require("url"));
/* https://docs.zksync.io/api/v0.2/ */
class ZksyncService extends base_network_service_1.BaseNetworkService {
  constructor(chainId, urls, websocketRpcUrls = [], logger) {
    if (!networks_1.ZksyncNetworks.includes(chainId)) {
      throw new Error(`The given chainId [${chainId}] is not supported by Zksync network`);
    }
    super(chainId, urls, websocketRpcUrls, logger);
  }
  getName() {
    return `Zksync_${this.name}`;
  }
  async fetchTransactions(contractAddress, fromBlockNumber, tillBlockNumber, fetchSize, sort = 'asc', page = 1, timeout = 60000) {
    //Api restriction: Only first 1000 items can be requested so make sure page * offset <= 1000.
    if (fetchSize * page > 1000) {
      throw new Error('ZksyncService: should: fetchSize*page<=1000');
    }
    const transactions = await axios_1.default.get(`${ZksyncService.API_BASE_URL}?module=account&action=txlist&address=${contractAddress}&startblock=${fromBlockNumber}&endblock=${tillBlockNumber}&page=${page}&offset=${fetchSize.toString()}&sort=${sort}`, {
      timeout: timeout,
      timeoutErrorMessage: 'Fetching transaction timeout'
    });
    return transactions.data;
  }
  async fetchTransactionReceipt(transactionHash) {
    throw new Error('Method not implemented');
    //HACK:BLOC-1821 Unfortunatly, this API does not work as expected.  It will be fixed in the BLOC-1821.
    /**
    const logs = await axios.get(
      `https://api.zksync.io/api/v0.2/transactions/${transactionHash}/data`,
      { timeout: 60000, timeoutErrorMessage: 'Fetching transaction receipt timeout' },
    );
    return logs.data; */
  }
  async fetchLogsByCallingApiAxiosResponse(contractAddress, eventSignature, topics, fromBlockNumber, tillBlockNumber) {
    const eventTopic = eventSignature ? ethers_1.ethers.utils.id(eventSignature) : null;
    let url = ZksyncService.API_BASE_URL;
    url += `?` + `module=logs`;
    url += `&` + `action=getLogs`;
    url += `&` + `address=${contractAddress}`;
    if (eventTopic) {
      url += `&` + `topic0=${eventTopic}`;
    }
    if (topics['1']) {
      url += `&` + `topic1=${topics['1']}`;
    }
    if (topics['2']) {
      url += `&` + `topic2=${topics['2']}`;
    }
    if (topics['3']) {
      url += `&` + `topic3=${topics['3']}`;
    }
    if (fromBlockNumber) {
      url += `&` + `fromBlock=${fromBlockNumber}`;
    }
    if (tillBlockNumber) {
      url += `&` + `toBlock=${tillBlockNumber}`;
    }
    const response = await axios_1.default.get(url, {
      timeout: 60000,
      timeoutErrorMessage: 'Fetching event log timeout'
    });
    if (response.status != 200) {
      throw new Error(`Exception in fetchLogsFromApi. chainId: ${this.chainId}, status code:${response.status}`);
    }
    return response;
  }
  async fetchLogsByCallingApi(contractAddress, abi, eventSignature, topics, fromBlockNumber, tillBlockNumber) {
    const interface_ = new ethers_1.ethers.utils.Interface(abi);
    const eventTopic = eventSignature ? ethers_1.ethers.utils.id(eventSignature) : null;
    let logs = [];
    //Api restriction: Only first 1000 items can be requested so make sure page * offset <= 1000.
    const offset = 100; //It is the maximum value that can be set
    for (let page = 1; page <= 10; page++) {
      let url = ZksyncService.API_BASE_URL;
      url += `?` + `module=logs`;
      url += `&` + `action=getLogs`;
      url += `&` + `address=${contractAddress}`;
      url += `&` + `offset=${offset}`;
      url += `&` + `page=${page}`;
      if (fromBlockNumber) {
        url += `&` + `fromBlock=${fromBlockNumber}`;
      }
      if (tillBlockNumber) {
        url += `&` + `toBlock=${tillBlockNumber}`;
      }
      const response = await axios_1.default.get(url, {
        timeout: 60000,
        timeoutErrorMessage: 'Fetching event log timeout'
      });
      if (response.status != 200) {
        throw new Error(`Exception in fetchLogsFromApi. chainId: ${this.chainId}, status code:${response.status}`);
      }
      //filter the required logs
      const filteredRawLogs = response.data.result.filter(rawLog => {
        if (eventTopic) {
          if (!this.isTopicsEqual(eventTopic, rawLog['topics'][0])) {
            return false;
          }
        }
        for (let i = 1; i <= 3; i++) {
          if (topics[i] && rawLog['topics'][i]) {
            if (!this.isTopicsEqual(topics[i], rawLog['topics'][i])) {
              return false;
            }
          }
        }
        return true;
      });
      let _logs = filteredRawLogs.map(rawLog => {
        const log = interface_.parseLog(rawLog);
        return {
          blockNumber: rawLog.blockNumber,
          timeStamp: rawLog.timeStamp,
          transactionHash: rawLog.transactionHash,
          args: log.args
        };
      });
      logs.push(..._logs);
      return logs;
    }
  }
  isTopicsEqual(topicA, topicB) {
    return ethers_1.BigNumber.from(topicA).eq(topicB);
  }
  async fetchTokensTransfers(address, contractAddress, fromBlockNumber, tillBlockNumber, sort = 'desc', page = 1, fetchSize = 10, timeout = 60000) {
    const request = {
      module: 'account',
      action: 'tokentx',
      address: address,
      startblock: fromBlockNumber,
      endblock: tillBlockNumber,
      page: page,
      offset: fetchSize,
      sort: sort,
      apikey: ""
    };
    if (contractAddress) {
      request.contractaddress = contractAddress;
    }
    const params = new url.URLSearchParams(request);
    const transactions = await axios_1.default.get(`https://block-explorer-api.mainnet.zksync.io/api?${params}`, {
      timeout: timeout,
      timeoutErrorMessage: 'Fetching erc20 token transfers timeout'
    });
    return transactions.data;
  }
}
exports.ZksyncService = ZksyncService;
ZksyncService.API_BASE_URL = 'https://block-explorer-api.mainnet.zksync.io/api';
